import Modal from "./Modal";
import OtherPlayer from "../OtherPlayer";

function PickSevenTargetModal({ players, onSelectTarget }) {
    return (
        <Modal>
            <h2 className="text-lg font-semibold mb-6">Swap hands with:</h2>
            <div className="flex gap-4">
                { players.map(p => {
                    return (
                        <OtherPlayer key={p.id} player={p} activePlayerId={null} onClick={() => onSelectTarget(p.id)}></OtherPlayer>
                    )
                }) }
            </div>
        </Modal>
    )
}

export default PickSevenTargetModal;